module.exports = __webpack_public_path__ + "09003074eeab6b617527cf4550f922a7.png";